import "./notificationsPage.scss";
import { useState, useContext } from "react";
import Sidebar from "../../components/sidebar/Sidebar";
import Navbar from "../../components/navbar/Navbar";
import { AuthContext } from "../../context/AuthContext";
import { useSidebarState } from "../../components/sidebar/SidebarStateContext";
import { Button, Tabs, Tab, Box } from "@mui/material";
import SettingsIcon from "@mui/icons-material/Settings";
import NotificationsIcon from "@mui/icons-material/Notifications";

// Importar componentes modulares
import NotificationsList from "./NotificationsList";
import NotificationSettings from "./NotificationSettings";

/**
 * Página de gestión de notificaciones del dashboard
 */
const DashboardNotifications = () => {
  const { currentUser, currentService, adminData } = useContext(AuthContext);
  const { collapsed } = useSidebarState();
  const [activeTab, setActiveTab] = useState(0); // 0: lista, 1: configuración

  // Clase para el contenedor basada en el estado de colapso
  const containerClass = collapsed ? "notificationsContainer collapsed" : "notificationsContainer";

  // Cambiar pestaña
  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  return (
    <div className="notifications">
      <Sidebar />
      <div className={containerClass}>
        <Navbar />
        
        <div className="title">
          <h1>Notificaciones del Dashboard</h1>
        </div>
        
        <Box sx={{ width: '100%', px: 2 }}>
          <Tabs 
            value={activeTab} 
            onChange={handleTabChange}
            indicatorColor="primary"
            textColor="primary"
            sx={{ 
              mb: 3,
              '& .MuiTabs-indicator': { backgroundColor: '#4678c3' },
              '& .Mui-selected': { color: '#4678c3 !important' }
            }}
          >
            <Tab 
              icon={<NotificationsIcon />} 
              label="Notificaciones" 
              iconPosition="start"
            />
            <Tab 
              icon={<SettingsIcon />} 
              label="Configuración" 
              iconPosition="start"
            />
          </Tabs>
          
          {/* Contenido según la pestaña seleccionada */}
          {activeTab === 0 && (
            <NotificationsList 
              adminData={adminData} 
              currentUser={currentUser} 
              currentService={currentService} 
            />
          )}
          
          {activeTab === 1 && (
            <NotificationSettings 
              currentUser={currentUser} 
              currentService={currentService} 
              adminData={adminData}
            />
          )}
        </Box>
      </div>
    </div>
  );
};

export default DashboardNotifications;